import {
  Component,
  EventEmitter,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, RouterModule } from '@angular/router';
// import { NavigationEnd, NavigationError, NavigationStart, Router, Event } from '@angular/router';
import { CommonModule } from '@angular/common';
// import {} from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LayoutService } from '../layout.service';
import { isNullOrUndefined } from '@app/shared/utils';
import { ChangeDetectionStrategy, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MessageApiService } from '@app/services/message-api.service';
import { ChangeDetectorRef } from '@angular/core';
import { MessageInterface } from '@app/interface/messages';
import { MatChipsModule } from '@angular/material/chips';
import { OrganizationApi } from '@app/services/organization-api.service';
import { Organizations } from '@app/interface/organizations';
import { AssistanceTicketApiService } from '@app/services/assistance-ticket-api.service';
import { AssistanceTicketInterface } from '@app/interface/assistance-ticket';
import { MatBadgeModule } from '@angular/material/badge';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  providers: [],
  imports: [
    CommonModule,
    RouterModule,
    // TODO: `HttpClientModule` should not be imported into a component directly.
    // Please refactor the code to add `provideHttpClient()` call to the provider list in the
    // application bootstrap logic and remove the `HttpClientModule` import from this component.
    // HttpClientModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    // MessagingModule,
    MatExpansionModule,
    MatChipsModule,
    MatBadgeModule,
  ],
  standalone: true,
})
export class SideMenuComponent implements OnInit {
  constructor(
    public auth: AngularFireAuth,
    private route: ActivatedRoute,
    private router: Router,
    private layoutService: LayoutService, // private router: Router
    private messageApiService: MessageApiService,
    public organizationService: OrganizationApi,
    private ticketApiService: AssistanceTicketApiService,
    private cdr: ChangeDetectorRef,
  ) {
    // this.router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationStart) {
    //     // Show loading indicator
    //     this.getorganizationId();
    //   }

    //   if (event instanceof NavigationEnd) {
    //     // Hide loading indicator
    //     this.getorganizationId();
    //   }

    //   if (event instanceof NavigationError) {
    //     // Hide loading indicator

    //     // Present error to user
    //     console.log(event);
    //   }
    // });
    this.layoutService.organizationId$.subscribe((organizationId) => {
      if (organizationId !== undefined) {
        this.organizationId = +organizationId;
        this.getProjects();
        this.getCompany();
      } else {
        console.log('Organization ID is undefined');
      }
    });

    // Refresh the "Notifiche e avvisi" / "Il tuo Commercialista" badges when
    // a push arrives while the app is in foreground (see
    // authorized-layout.component.ts#showForegroundNotification). Without
    // this the counts were only recomputed on ngOnInit/ngAfterViewInit and a
    // menu click, so they'd stay stale for the rest of the session.
    // NOTE: like the subscription above, this is never unsubscribed - this
    // component effectively lives for the whole authenticated session, so
    // the leak is bounded (not per-navigation); a proper OnDestroy cleanup
    // for all of this class's subscriptions is tracked separately.
    this.layoutService.newNotification$.subscribe(() => {
      this.loadMessagesCount();
    });
  }

  // projects: projectInterface[] = [];
  isLoading: boolean = false;
  // company?: companyInterface = undefined;
  organizationId?: number;
  organization_data: Organizations | null = null;
  readonly panelOpenState = signal(false);
  messages: MessageInterface[] = [];
  messagesNumber: number = 0;
  tickets: AssistanceTicketInterface[] = [];
  ticketsNumber: number = 0;

  @Output() clickOnVoice: EventEmitter<void> = new EventEmitter();

  ngOnInit() {
    this.getorganizationId();
    this.getOrganization();
    this.loadMessagesCount();
  }

  ngAfterViewInit() {
    this.loadMessagesCount();
    this.cdr.detectChanges();
  }

  clickOnVoiceButton() {
    this.clickOnVoice.emit();
    this.loadMessagesCount();
    this.cdr.detectChanges();
  }

  // both messages and tickets
  loadMessagesCount(): void {
    if (this.router.url.includes('home-redirect')) {
      return; // Exit if the string is found
    }

    this.isLoading = true;
    // this.cdr.detectChanges();

    // Prepare filter params
    const filterParams: any = {};
    filterParams.is_read = false;

    this.messageApiService
      .getAllMessages<MessageInterface>(this.organizationId || 0, filterParams)
      .subscribe({
        next: (response) => {
          // Filter and map messages
          this.messages = response.results;
          this.messagesNumber = response.results.length;
          console.log('Numero messaggi', this.messagesNumber);

          // this.isLoading = false;

          this.cdr.detectChanges(); // Force change detection after data
        },
        error: (error) => {
          // this.isLoading = false;
          console.error('Error loading messages:', error);

          this.cdr.detectChanges(); // Force change detection after data
        },
      });

    // filter for IN tickets
    filterParams.is_read = false;
    filterParams.type = 'IN';

    this.ticketApiService
      .getAllTickets<AssistanceTicketInterface>(
        this.organizationId || 0,
        filterParams,
      )
      .subscribe({
        next: (response2) => {
          // Filter and map messages
          this.tickets = response2.results;
          this.ticketsNumber = response2.results.length;
          // console.log('Numero tickets', this.ticketsNumber);

          // this.isLoading = false;

          this.cdr.detectChanges(); // Force change detection after data
        },
        error: (error) => {
          // this.isLoading = false;
          console.error('Error loading tickets:', error);

          this.cdr.detectChanges(); // Force change detection after data
        },
      });

    this.isLoading = false;
  }

  getorganizationId() {
    // console.log('Getting company ID');
    this.route.paramMap.subscribe((params) => {
      // console.log('Getting company ID');
      let organizationId = params.get('organizationId') || undefined;
      // console.log('Company ID:', organizationId);
      if (organizationId !== undefined) {
        this.organizationId = +organizationId;
        this.getProjects();
        this.getCompany();
      } else {
        setTimeout(() => {
          this.getorganizationId();
        }, 1000);
      }
    });
  }

  getOrganization() {
    if (!this.organizationId) {
      console.error('Organization ID is not available');
      return;
    }

    this.isLoading = true;

    const filterParams = {
      organization_id: this.organizationId,
    };

    this.organizationService
      .getOrganization<Organizations>(this.organizationId, filterParams)
      .subscribe({
        next: (organization_data: Organizations) => {
          this.organization_data = organization_data; // Store the organization data

          // Apply theme based on organization source
          // this.applyOrganizationTheme(this.organization_data.source);

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error loading organization:', err);
          this.cdr.detectChanges();
        },
        // Remove complete() if you're handling everything in next/error
      });
  }

  getCompany(): void {
    if (!isNullOrUndefined(this.organizationId) && this.organizationId !== 0) {
      // this.companyService.getCompanyDetail(this.organizationId, {}).subscribe({
      //   next: (res) => {
      //     this.company = res;
      //   },
      //   error: (error) => {
      //     console.error(error);
      //   },
      // });
    } else {
      console.warn('Company ID is undefined or null or 0');
      // setTimeout(() => {
      //   this.getCompany();
      //   this.getProjects();
      // }, 1000);
    }
  }
  getProjects(): void {
    // if (this.organizationId !== undefined) {
    //   this.isLoading = true;
    //   this.projectService.getProjectList(this.organizationId).subscribe(
    //     {
    //       next: (res) => {
    //         this.projects = res.results;
    //         this.isLoading = false;
    //       },
    //       error: (error) => {
    //         console.log(error);
    //         // this.isLoading = true;
    //         this.isLoading = false;
    //       },
    //     }
    //     // map(
    //     // )
    //   );
    // } else {
    //   this.projects = [];
    //   console.error('Company ID is undefined');
    // }
  }
}
